import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';

/* Retrieve all zones which are enabled for Temperature adjustment
 by having one space/area as member. */
export function GetTemperatureAdjustmentsList() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.get_Temperature_adjustments_list).then(response => {
            dispatch(global_error_handling(response));  
            if(response !== null && response !== undefined)
             dispatch(actionToStoreSuccess(response,types.GET_TEMPERATURE_ADJUSTMENTS_SUCCESSFULL));
         }).catch(error => {
             throw error;
         })
     }
 }




//Submit / Post Zones
export function PostEnableDisableTempAdjustments(data) { 
    return function (dispatch) {
       return APIutil.editDataAPI(url.get_Temperature_adjustments_list,data).then(response => {
        dispatch(global_error_handling(response));     
        if(response.status === 200)
          dispatch(GetTemperatureAdjustmentsList());
        }).catch(error => {
            throw error;
        })
    }
}

/* Action to Store method returns the action type with the API response. 
The response object{type,response} will be returned to the Reducer checking 
it type and updates the state. */

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}















